import Banner from './react/Banner';
import MarketingBanner from './react/MarketingBanner';
import banner from './js/_banner';
export { banner, MarketingBanner };
export default Banner;